import React, { useState } from 'react';
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { Button, Form, message, Modal, Select, Spin } from "antd";
import dayjs from "dayjs";

interface IProps {
  type: "transportAll" | "transportWork" | null;
  title: string;
  getReport: (payload: {
	manufactureYear: number;
	seasonStatus?: boolean | null;
	checkStatus?: boolean | null;
  }) => Promise<Blob>;

  show: boolean;
  onHide: () => void;
}

const ReportTransportModal = (props: IProps) => {
  const [ form ] = useForm();
  const { t } = useTranslation();
  const [ loading, setLoading ] = useState<boolean>(false);
  const [ selectedYear, setSelectedYear ] = useState<string>('');
  const [selectedSeasonStatus, setSelectedSeasonStatus] = useState<boolean | null>(true);

  const years = Array.from({ length: 20 }, (_, i) => (2025 - i).toString());

  const handleSubmit = async () => {
	try {
	  const values = await form.validateFields();
	  setLoading(true);

	  const payload = props.type === "transportAll"
		? { manufactureYear: Number(selectedYear) }
		: { manufactureYear: Number(selectedYear), seasonStatus: selectedSeasonStatus, checkStatus:true};


	  const blob = await props.getReport(payload);


	  const url = window.URL.createObjectURL(blob);
	  const link = document.createElement("a");
	  link.href = url;
	  link.setAttribute(
		"download",
		`Report_${ props.type }_${ dayjs().format("YYYY-MM-DD") }.xlsx`
	  );
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);

	  message.success(t('reports.download_success'));
	} catch (error: any) {
	  Modal.error({
		title: t("msg.error"),
		content: error.message || t('reports.download_failed'),
	  });
	} finally {
	  setLoading(false);
	}
  };

  const handleHide = () => {
	form.resetFields();
	setSelectedYear('');
	setSelectedSeasonStatus(true);
	props.onHide();
  };

  return (
	<Modal
	  title={ props.title }
	  open={ props.show }
	  onCancel={ handleHide }
	  onOk={ handleSubmit }
	  okText={ t('general.create') }
	  width={ 500 }
	  footer={ null }
	>
	  <Spin spinning={ loading } tip={ t('reports.loading') }>
		<Form form={ form } layout="vertical" autoComplete="off">
		  <div>
			<Form.Item
			  name="manufactureYear"
			  label={ t('reports.select_years') }
			  rules={ [ { required: true, message: t('msg.fill_in_the_field') } ] }
			>
			  <Select
				style={ { width: "300px" } }
				value={ selectedYear }
				onChange={ setSelectedYear }
				placeholder={ t('reports.select_years') }
			  >
				{ years.map((year) => (
				  <Select.Option key={ year } value={ year }>
					{ year }
				  </Select.Option>
				)) }
			  </Select>
			</Form.Item>
			{ props.type !== "transportAll" && (
			  <Form.Item
				name="seasonStatus"
				label={ t("Сезон работы") }
				valuePropName="checked"
			  >
				<Select
				  style={ { width: "300px" } }
				  value={selectedSeasonStatus !== null ? String(selectedSeasonStatus) : 'null'}
				  onChange={(value: string) =>
					setSelectedSeasonStatus(value === 'null' ? null : value === 'true')
				  }
				  placeholder={t("select_season_status")}
				>
				  <Select.Option value="true">{t("Осенний")}</Select.Option>
				  <Select.Option value="false">{t("Весенние")}</Select.Option>
				  <Select.Option value="null">{t("все")}</Select.Option>
				</Select>

			  </Form.Item>
			) }
		  </div>
		  <Button
			style={ { width: "200px" } }
			type="primary"
			block
			onClick={ handleSubmit }
		  >
			{ t('reports.download_report') }
		  </Button>
		</Form>
	  </Spin>
	</Modal>
  );
};

export default ReportTransportModal;
